
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'cm_product-item grid-item__link' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container'
                }, _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '424'
                }) : null, _createElement('div', { 'className': 'cm_badge-container cm_badge-left' }, this.is_new ? _createElement('span', {
                    'className': 'badge-new',
                    'key': '707'
                }, 'NEW') : null)), _createElement('div', { 'className': 'cm_product-item__details' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'cm_product-item__title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_product-item__sku-container' }, this.sku ? _createElement('div', {
                    'className': 'cm_product-item__sku',
                    'key': '1059'
                }, _createElement('span', { 'className': 'sku-title' }, 'SKU: '), _createElement('span', mergeProps({ 'className': 'sku-value' }, { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } }))) : null), _createElement('div', { 'className': 'cm_product-item__price-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_compare',
                    'key': '1392'
                }, '\n        ', this.formatPrice(this.compare_at_price), '\n      ') : null, _createElement('div', { 'className': 'cm_product-item__price' }, this.price_varies ? _createElement('span', { 'key': '1595' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_set',
                    'key': '1739'
                }, '\n        ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n      ') : null)), _createElement('div', { 'className': 'cm_product-item__buttons' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '21731'
                    }, '\n          ', this.out_of_stock ? 'Notify Me' : 'Select options', '\n        ')] : null, this.variant_ids.length === 1 && this.out_of_stock ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'key': '24361'
                    }, 'Notify Me')] : null, this.variant_ids.length === 1 && !this.out_of_stock ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '26241'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '26243'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '26245'
                    }) : null,
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'key': '26247'
                    }, '\n          Add to cart', this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : '', '\n        ')
                ] : null)), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '33290'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '3728'
                }) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []